import { render } from "./Userauth.vue?vue&type=template&id=b1611058"
import script from "./Userauth.vue?vue&type=script&lang=js"
export * from "./Userauth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__